//
//
//
//
//
//

export default {
  name: 'app',
  mounted() {
    /*去掉iphone手机滑动默认行为*/
    $('body').on('touchmove', function (event) {
        event.preventDefault();
    });
  }
}



// WEBPACK FOOTER //
// ./src/App.vue